import { matchPath } from 'react-router-dom';
import { DIAGNOSTICS_ROUTE } from '../diagnostics/routes';

const FLUID_CONTAINER_MODULE_ROUTES: readonly string[] = [DIAGNOSTICS_ROUTE];

export const requiresFluidContainer = (pathname: string): boolean =>
  FLUID_CONTAINER_MODULE_ROUTES.some((path) => matchPath({ path, end: false }, pathname) !== null);
